import { Component, Input } from '@angular/core';
import { capitalize } from 'lodash';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'transcript-sentiment-icon',
    templateUrl: './transcript-sentiment-icon.component.html',
    styleUrls: ['./transcript-sentiment-icon.component.scss'],
    standalone: true,
    imports: [
        MatIcon,
        NgClass,
        MatTooltip,
    ],
})
export class TranscriptSentimentIconComponent {
  @Input({ required: true })
  sentiment: string;

  @Input()
  sentimentScore: number;

  private readonly _sentimentIcons: Record<string, string> = {
    positive: 'sentiment_satisfied',
    neutral: 'sentiment_neutral',
    negative: 'sentiment_dissatisfied',
  };

  get sentimentIcon(): string {
    return this._sentimentIcons[this.sentiment] || '';
  }

  get capitalizedSentiment(): string {
    return `${capitalize(this.sentiment)} `;
  }
}
